import React from 'react';
import { FILTER_DROP_SHADOW_DEFAULT, colorCoreWhite1000 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { INDENT } from '@yme/tokens/sizes';
import { HeadingLevel4 } from '@yme/tokens/typography';
import { SeparatorElementStyled } from './styled';
export function SubTitlePanel(props) {
    const { subtitle, date } = props;
    if (date || subtitle) {
        return (React.createElement(FlexWrapper, { mbTablet: INDENT.xxxxs, flexWrap: "wrap", filter: FILTER_DROP_SHADOW_DEFAULT },
            React.createElement(HeadingLevel4, { color: colorCoreWhite1000 }, subtitle),
            subtitle && date && (React.createElement(SeparatorElementStyled, { as: "span", color: colorCoreWhite1000 }, "|")),
            React.createElement(HeadingLevel4, { color: colorCoreWhite1000, whiteSpace: "nowrap" }, date)));
    }
    return null;
}
SubTitlePanel.displayName = 'SubTitlePanel_AEMComponent';
